import React, { useContext, useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import useViewportResize from './useViewportResize';

import { DataContext } from './Context/DataContext';

import Root from './Root';
import LoadingSpinner from './components/LoadingSpinner';
import AppError from './components/AppError';
import Home from './components/Sections/Home';
import Why from './components/Sections/WhyUs';
import About from './components/Sections/About';
import TeamPartners from './components/Sections/TeamPartners';
import Clients from './components/Sections/Clients';
import Awards from './components/Sections/Awards';
import Contact from './components/Sections/Contact';
import Page from './components/Sections/Page'; // Generic page component
import NotFound from './components/Sections/NotFound';

function App() {
    const { isLoading, isError, sectionsData } = useContext(DataContext);
    useViewportResize();

    useEffect(() => {
        if (isLoading) {
            document.body.classList.add('mga-loading');
        } else {
            document.body.classList.remove('mga-loading');
        }
    }, [isLoading]);
    
    if (isLoading) {
        return <LoadingSpinner />;
    }

    if (isError) {
        return <AppError />;
    }

    const sectionComponentsMap = {
        'home': <Home />,
        'why-us': <Why />,
        'about-us': <About />,
        'team-partners': <TeamPartners />,
        'clients': <Clients />,
        'awards': <Awards />,
        'contact': <Contact />,
        'page': <Page />,
    };

    const appChildren = sectionsData?.map((section) => {
        const SectionComponent = sectionComponentsMap[section.identifier] || sectionComponentsMap['page'];
        if (section.identifier === 'external') {
            return null;
        }

        return {
            path: section.slug,
            element: React.cloneElement(SectionComponent, { key: section.identifier, data: section }),
            errorElement: <AppError />,
        };
    }).filter(Boolean);

    const routes = [
        {
            element: <Root />,
            children: appChildren,
            errorElement: <NotFound />
        },
    ];

    const router = createBrowserRouter(routes, {});

    return (
        <RouterProvider router={router} />
    );
}

export default React.memo(App);